// @ts-ignore
import { env } from "./env";

const isProduction = env.VITE_ENV === "production";

const config: {
  isProduction: boolean;
  APP_NAME: string;
  BACKEND_URL: string;
  FRONTEND_URL: string;
  SERVER_FRONTEND_PORT: string;
  LOGTO_APP_ID: string;
  LOGTO_ENDPOINT: string;
  LOGTO_CALLBACK: string;
  LOGTO_RESOURCE: string;
  SALES_CALENDLY: string;
  SALES_CALENDLY_KICKOFF: string;
  POSTHOG_KEY: string;
  POSTHOG_HOST: string;
  SENTRY_DSN: string;
  SENTRY_TRACES_SAMPLE_RATE: string;
  SENTRY_REPLAY_SESSION_SAMPLE_RATE: string;
  SENTRY_REPLAY_ONERROR_SAMPLE_RATE: string;
  HELP_PAGE_URL: string;
  CUSTOM_ENVIRONMENT: string;
} = {
  isProduction: isProduction,
  APP_NAME: env.VITE_APP_NAME,
  BACKEND_URL: env.VITE_BACKEND_URL,
  FRONTEND_URL: env.VITE_FRONTEND_URL,
  SERVER_FRONTEND_PORT: env.VITE_SERVER_FRONTEND_PORT,
  LOGTO_APP_ID: env.VITE_LOGTO_APP_ID,
  LOGTO_ENDPOINT: env.VITE_LOGTO_ENDPOINT,
  LOGTO_CALLBACK: env.VITE_LOGTO_CALLBACK,
  LOGTO_RESOURCE: env.VITE_LOGTO_RESOURCE,
  SALES_CALENDLY: env.VITE_SALES_CALENDLY,
  SALES_CALENDLY_KICKOFF: env.VITE_SALES_CALENDLY_KICKOFF,
  POSTHOG_KEY: env.VITE_PUBLIC_POSTHOG_KEY,
  POSTHOG_HOST: env.VITE_PUBLIC_POSTHOG_HOST,
  SENTRY_DSN: env.VITE_SENTRY_DSN,
  SENTRY_TRACES_SAMPLE_RATE: env.VITE_SENTRY_TRACES_SAMPLE_RATE,
  SENTRY_REPLAY_SESSION_SAMPLE_RATE: env.VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE,
  SENTRY_REPLAY_ONERROR_SAMPLE_RATE: env.VITE_SENTRY_REPLAY_ONERROR_SAMPLE_RATE,
  HELP_PAGE_URL: env.VITE_PUBLIC_HELP_PAGE_URL,
  CUSTOM_ENVIRONMENT: env.VITE_CUSTOM_ENVIRONMENT,
};

export default config;
